import { useState } from 'react';
import { ChevronRight, X } from 'lucide-react';
import { WELCOME_STEPS, HOW_TO_TOPICS } from '../lib/constants';

export function WelcomeFlow({ onComplete, darkMode }) {
  const [step, setStep] = useState(0);
  const T = darkMode
    ? { BG: '#080c10', PANEL: 'rgba(15,18,28,0.95)', BORDER: 'rgba(162,128,255,0.1)', TEXT: '#d0c8f0', DIM: '#5a5070' }
    : { BG: '#f0f4f8', PANEL: 'rgba(255,255,255,0.98)', BORDER: 'rgba(100,80,160,0.15)', TEXT: '#1a1a2e', DIM: '#7a7a9e' };

  const current = WELCOME_STEPS[step];

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9998,
      }}
    >
      <div
        style={{
          background: T.PANEL,
          border: `1px solid ${T.BORDER}`,
          borderRadius: 20,
          padding: 32,
          maxWidth: 400,
          textAlign: 'center',
          animation: 'slideUp 0.3s ease',
        }}
      >
        <div style={{ fontSize: 32, marginBottom: 16 }}>🛡️</div>
        <h2 style={{ fontSize: 18, fontWeight: '700', color: T.TEXT, margin: '0 0 8px' }}>{current.title}</h2>
        <p style={{ fontSize: 12, color: T.DIM, margin: '0 0 16px' }}>{current.subtitle}</p>
        <p style={{ fontSize: 13, color: T.TEXT, lineHeight: 1.6, margin: '0 0 28px' }}>{current.body}</p>

        <div style={{ display: 'flex', gap: 12 }}>
          <button
            onClick={onComplete}
            style={{
              flex: 1,
              padding: '12px 16px',
              background: 'transparent',
              border: `1px solid ${T.BORDER}`,
              borderRadius: 10,
              color: T.DIM,
              fontSize: 12,
              fontWeight: '600',
              cursor: 'pointer',
            }}
          >
            Skip
          </button>
          <button
            onClick={() => (step === WELCOME_STEPS.length - 1 ? onComplete() : setStep(step + 1))}
            style={{
              flex: 1,
              padding: '12px 16px',
              background: 'rgba(242,107,59,0.1)',
              border: '1px solid rgba(242,107,59,0.3)',
              borderRadius: 10,
              color: '#f26b3b',
              fontSize: 12,
              fontWeight: '700',
              cursor: 'pointer',
            }}
          >
            {step === WELCOME_STEPS.length - 1 ? 'Start' : 'Next'} <ChevronRight size={12} style={{ display: 'inline', marginLeft: 4 }} />
          </button>
        </div>
      </div>
    </div>
  );
}

export function HowToGuide({ onClose, darkMode }) {
  const [expandedTopic, setExpandedTopic] = useState(0);
  const T = darkMode
    ? { BG: '#080c10', PANEL: 'rgba(15,18,28,0.95)', BORDER: 'rgba(162,128,255,0.1)', TEXT: '#d0c8f0', DIM: '#5a5070' }
    : { BG: '#f0f4f8', PANEL: 'rgba(255,255,255,0.98)', BORDER: 'rgba(100,80,160,0.15)', TEXT: '#1a1a2e', DIM: '#7a7a9e' };

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9998,
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: T.PANEL,
          border: `1px solid ${T.BORDER}`,
          borderRadius: 20,
          maxWidth: 500,
          maxHeight: '80vh',
          overflow: 'auto',
          animation: 'slideUp 0.3s ease',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ padding: 24, borderBottom: `1px solid ${T.BORDER}`, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h2 style={{ fontSize: 16, fontWeight: '700', color: T.TEXT, margin: 0 }}>How To</h2>
          <button
            onClick={onClose}
            style={{ background: 'none', border: 'none', cursor: 'pointer', color: T.DIM, padding: 8 }}
          >
            <X size={20} />
          </button>
        </div>

        <div style={{ padding: '12px' }}>
          {HOW_TO_TOPICS.map((topic, idx) => (
            <button
              key={idx}
              onClick={() => setExpandedTopic(expandedTopic === idx ? null : idx)}
              style={{
                width: '100%',
                padding: '14px 16px',
                marginBottom: 8,
                background: T.BG,
                border: `1px solid ${T.BORDER}`,
                borderRadius: 12,
                color: T.TEXT,
                textAlign: 'left',
                cursor: 'pointer',
                fontSize: 13,
                fontWeight: '600',
              }}
            >
              {topic.title}
            </button>
          ))}
        </div>

        {expandedTopic !== null && (
          <div style={{ padding: '0 24px 24px', borderTop: `1px solid ${T.BORDER}` }}>
            <p style={{ fontSize: 12, color: T.TEXT, lineHeight: 1.7, margin: 0 }}>
              {HOW_TO_TOPICS[expandedTopic].content}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
